<template>
  <div class="card py-1 px-2 mb-1">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div style="font-weight:600">{{upload.originalname}}</div>
      </div>
      <a href="javascript:;" @click="$emit('remove', index)" style="font-weight: 600">DELETE</a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["upload", "index"]
};
</script>

<style>
</style>
